import React, { useState, useEffect } from "react";
import { Nav } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { TbLayoutDashboardFilled } from "react-icons/tb";
import { MdLeaderboard } from "react-icons/md";
import {
  FaClipboardCheck,
  FaHourglassHalf,
  FaUsers,
  FaArchive,
} from "react-icons/fa";
import { FaFolderClosed } from "react-icons/fa6";
import { MdWorkHistory } from "react-icons/md";
import "../App.css";
import "../Styles/Dashboard.css";

import DashboardContent from "./DashboardContent";
import ModulePage from "../Pages/ModulePage";
import ResultPage from "../Pages/ResultPage";
import LeaderboardPage from "../Pages/LeaderboardPage";
import Practice from "./Practice";
import Archive from "../Pages/ArchivePage";
import Users from "../Pages/Users";
import AuditLogs from "../Pages/AuditLogs";

function Menus() {
  const [activeKey, setActiveKey] = useState("modules");
  const [userRole, setUserRole] = useState("");
  const location = useLocation();

  useEffect(() => {
    const loggedInUser = JSON.parse(localStorage.getItem("user"));

    if (loggedInUser && loggedInUser.user_role) {
      setUserRole(loggedInUser.user_role);

      const requestedTab = location.state?.activeTab;

      if (requestedTab === "modules") {
        setActiveKey("modules");
      } else if (loggedInUser.user_role === "learner") {
        setActiveKey("modules");
      } else if (loggedInUser.user_role === "admin") {
        setActiveKey("dashboard");
      }
    }
  }, [location.state]);

  return (
    <div className="dashboard-layout">
      <div className="d-md-none horizontal-icons fixed-bottom dashboard-mobile-nav">
        <Nav
          className="d-flex justify-content-around m-0 p-0"
          activeKey={activeKey}
          onSelect={(selectedKey) => setActiveKey(selectedKey)}
        >
          {userRole === "admin" && (
            <Nav.Item>
              <Nav.Link
                eventKey="dashboard"
                className="text-center px-0 dashboard-mobile-link"
              >
                <TbLayoutDashboardFilled size={20} />
                <div style={{ fontSize: "12px" }}>Dashboard</div>
              </Nav.Link>
            </Nav.Item>
          )}

          <Nav.Item>
            <Nav.Link
              eventKey="modules"
              className="text-center px-0 dashboard-mobile-link"
            >
              <FaFolderClosed size={20} />
              <div style={{ fontSize: "12px" }}>Modules</div>
            </Nav.Link>
          </Nav.Item>

          {userRole === "admin" && (
            <Nav.Item>
              <Nav.Link
                eventKey="results"
                className="text-center px-0 dashboard-mobile-link"
              >
                <FaClipboardCheck size={20} />
                <div style={{ fontSize: "12px" }}>Results</div>
              </Nav.Link>
            </Nav.Item>
          )}

          {userRole === "admin" && (
            <Nav.Item>
              <Nav.Link
                eventKey="leaderboard"
                className="text-center px-0 dashboard-mobile-link"
              >
                <MdLeaderboard size={20} />
                <div style={{ fontSize: "12px" }}>Leaderboard</div>
              </Nav.Link>
            </Nav.Item>
          )}

          {userRole === "admin" && (
            <Nav.Item>
              <Nav.Link
                eventKey="users"
                className="text-center px-0 dashboard-mobile-link"
              >
                <FaUsers size={20} />
                <div style={{ fontSize: "12px" }}>Users</div>
              </Nav.Link>
            </Nav.Item>
          )}

          {userRole === "admin" && (
            <Nav.Item>
              <Nav.Link
                eventKey="archive"
                className="text-center px-0 dashboard-mobile-link"
              >
                <FaArchive size={20} />
                <div style={{ fontSize: "12px" }}>Archive</div>
              </Nav.Link>
            </Nav.Item>
          )}

          {userRole === "admin" && (
            <Nav.Item>
              <Nav.Link
                eventKey="auditLogs"
                className="text-center px-0 dashboard-mobile-link"
              >
                <MdWorkHistory size={20} />
                <div style={{ fontSize: "12px" }}>Logs</div>
              </Nav.Link>
            </Nav.Item>
          )}

          {userRole !== "admin" && (
            <Nav.Item>
              <Nav.Link
                eventKey="practice"
                className="text-center px-0 dashboard-mobile-link"
              >
                <FaHourglassHalf size={20} />
                <div style={{ fontSize: "12px" }}>Practice</div>
              </Nav.Link>
            </Nav.Item>
          )}
        </Nav>
      </div>

      <div className="dashboard-layout-row">
        <aside className="d-none d-md-block dashboard-sidebar">
          <Nav
            className="flex-column p-3 text-start side-nav"
            activeKey={activeKey}
            onSelect={(selectedKey) => setActiveKey(selectedKey)}
          >
            {userRole === "admin" && (
              <Nav.Link
                eventKey="dashboard"
                className="dashboard-menu-link"
              >
                <TbLayoutDashboardFilled /> Dashboard
              </Nav.Link>
            )}
            <Nav.Link eventKey="modules" className="dashboard-menu-link">
              <FaFolderClosed /> Modules
            </Nav.Link>
            {userRole === "admin" && (
              <Nav.Link eventKey="results" className="dashboard-menu-link">
                <FaClipboardCheck /> Results
              </Nav.Link>
            )}
            {userRole === "admin" && (
              <Nav.Link
                eventKey="leaderboard"
                className="dashboard-menu-link"
              >
                <MdLeaderboard /> Leaderboard
              </Nav.Link>
            )}
            {userRole !== "admin" && (
              <Nav.Link eventKey="practice" className="dashboard-menu-link">
                <FaHourglassHalf /> Practice
              </Nav.Link>
            )}
            {userRole === "admin" && (
              <Nav.Link eventKey="users" className="dashboard-menu-link">
                <FaUsers /> Users
              </Nav.Link>
            )}
            {userRole === "admin" && (
              <Nav.Link eventKey="archive" className="dashboard-menu-link">
                <FaArchive /> Archive
              </Nav.Link>
            )}
            {userRole === "admin" && (
              <Nav.Link
                eventKey="auditLogs"
                className="dashboard-menu-link"
              >
                <MdWorkHistory /> Audit Logs
              </Nav.Link>
            )}
          </Nav>
        </aside>

        <div className="dashboard-main-column">
          {activeKey === "dashboard" && userRole === "admin" && (
            <DashboardContent />
          )}
          {activeKey === "modules" && <ModulePage />}
          {activeKey === "results" && userRole === "admin" && <ResultPage />}
          {activeKey === "leaderboard" && userRole === "admin" && (
            <LeaderboardPage />
          )}
          {activeKey === "users" && userRole === "admin" && <Users />}
          {activeKey === "practice" && userRole !== "admin" && <Practice />}
          {activeKey === "archive" && userRole === "admin" && <Archive />}
          {activeKey === "auditLogs" && userRole === "admin" && <AuditLogs />}
        </div>
      </div>
    </div>
  );
}

export default Menus;
